// Copyright (C) 2020 One More Game - All Rights Reserved
// Unauthorized copying of any files within this project, via any medium, is strictly prohibited
// Proprietary and confidential

import React, { useState, useEffect } from "react"
import SpeechBubble from "../components/SpeechBubble"

interface ChatMessage {
  id: number
  body: string
  isSender?: boolean
}

interface ChatProps {
  messages: ChatMessage[]
  className?: string
}

const ChatDialogue: React.FC<ChatProps> = ({ messages, className }) => {
  const [currCount, setCount] = useState(0)
  const splay = 2000

  useEffect(() => {
    const interval = setInterval(() => {
      setCount(count => {
        // Stop displaying messages once we've seen them all
        if (count >= messages.length - 1) clearInterval(interval)
        return count + 1
      })
    }, splay)
    return () => clearInterval(interval)
  })

  return (
    <span className={className}>
      {messages.map((message, idx) => (
        <SpeechBubble
          key={message.id}
          message={message.body}
          isSender={message.isSender}
          hidden={idx > currCount}
        />
      ))}
    </span>
  )
}

ChatDialogue.defaultProps = {
  className: "",
  messages: [],
}

export default ChatDialogue
export { ChatMessage }
